<div class="loginBgImg">
<div class="row loginArea">
	<div class="col-lg-4 offset-lg-4 col-sm-4">
		<div class="card p-4 login_form">
			<form  (submit)="onsubmit(formpost)" #formpost="ngForm" method="post">
				<div class="text-center login_title">
					<h4>Welcome back !</h4>
					<p>We're so excited to see again !</p>
				</div>
				<div class="form-group pt-4">
					<label for="email">Email</label>
					<input type="email" name="email" class="form-control login_input" ngModel #email="ngModel" required="required"  #email="ngModel" placeholder="abc@gmail.com" [ngClass]="{ 'is-invalid': formpost.submitted && email.invalid }" required [email]="true">
					<div *ngIf="formpost.submitted && email.invalid" class="invalid-feedback">
                       <div *ngIf="email.errors.required">Email is required</div>
                       <div *ngIf="email.errors.email">Email must be a valid email address</div>
                    </div>
				</div>
				<div class="form-group">
					<label for="password">Password</label>
					<input type="password" name="password" class="form-control login_input" ngModel #password="ngModel" required="required" [ngClass]="{ 'is-invalid': formpost.submitted && password.invalid }">
					<div *ngIf="formpost.submitted && password.invalid" class="invalid-feedback">
                       <div *ngIf="password.errors.required">Password is required</div>
                    </div>
				</div>
				<a href="#">Forgot your password?</a>
				<input type="submit" name="submit" class="form-control btn btn-primary my-3 login_submit" value="Login">
			</form>
			<p class="login_reg">Need an account? <a routerLink="/register">Register</a></p>
		</div>
	</div>
</div>
</div>


